import { useEffect, useState } from 'react';

export function useImageWithFallback(
    src: string | null | undefined,
    fallbackSrc: string
): string {
    const [imgSrc, setImgSrc] = useState<string>(fallbackSrc);

    useEffect(() => {
        if (!src) {
            setImgSrc(fallbackSrc);
            return;
        }
        let active = true;
        const image = new Image();
        image.crossOrigin = 'anonymous';
        image.decoding = 'async';
        image.src = src;
        image.onload = () => {
            if (active && image.complete) {
                setImgSrc(src);
            }
        };
        image.onerror = () => {
            if (active) {
                setImgSrc(fallbackSrc);
            }
        };
        return () => {
            active = false;
        };
    }, [src, fallbackSrc]);

    return imgSrc;
}
